/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2, breakpoints } from '@coursera/cds-core';

type Props = {
  careerGoal: JSX.Element | null;
  ctaButton: JSX.Element;
};

const styles = {
  container: css`
    border-radius: var(--cds-border-radius-200);
    border: 2px solid var(--cds-color-neutral-stroke-primary-weak);
    margin: var(--cds-spacing-600) 0;

    &.cds-grid-item {
      padding: var(--cds-spacing-200) var(--cds-spacing-300);
    }
  `,

  careerGoal: css`
    ${breakpoints.up('sm')} {
      margin-right: var(--cds-spacing-200);
    }
  `,
};

/**
 * @description Module that displays the user's career goal and a call to action button.
 */
const CareerGoalBannerModule = ({ careerGoal, ctaButton }: Props) => {
  if (!careerGoal) {
    return null;
  }
  return (
    <Grid item xs={12} container alignItems="center" css={styles.container}>
      <Grid item xs={12} sm="auto">
        <Typography2 variant="bodyPrimary" component="h4" css={styles.careerGoal}>
          {careerGoal}
        </Typography2>
      </Grid>
      <Grid item xs={12} sm={3}>
        {ctaButton}
      </Grid>
    </Grid>
  );
};

export default CareerGoalBannerModule;
